module.exports = __webpack_public_path__ + "img/world_hard_menu_pre.5d002fb1.png";